import AIcon from '@/components/A/AIcon/AIcon'
import styles from './FullscreenBtn.module.less'


interface Props {
  isFullscreen: boolean
  onClick: (isFullscreen: boolean) => void
}

function FullscreenBtn(props: Props) {
  const { isFullscreen = false, onClick } = props

  const handleClick = () => {
    onClick(!isFullscreen)
  }

  return <div className={styles.fullscreenBtn} onClick={handleClick}>
    <AIcon type={
      isFullscreen ? 'icon-line-global_EnterFullScreen' : 'icon-line-global_FullScreen'
    } width={14} height={14} />
  </div>
}

export default FullscreenBtn